/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/sort-styles */
import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  accordionContainer: {
    backgroundColor: colors.lightestGrey,
    borderRadius: 10,
    marginTop: 20,
    padding: 10,
  },
  accordionContentContainer: {
    borderColor: colors.placeholder,
    borderTopWidth: 1,
    marginVertical: 5,
    paddingHorizontal: 10,
  },
  accordionTitleContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  buttonContainer: { borderRadius: 20 },
  buttonText: { fontSize: 18 },
  calendarContainer: { alignItems: "center", flexDirection: "row" },
  container: { height: "100%", padding: 10 },
  dateText: { fontFamily: typography.primary.normal, fontSize: 12, marginLeft: 5 },
  description: { fontFamily: typography.primary.normal, marginTop: 10 },
  dividerView: {
    borderColor: colors.lightGrey,
    borderRadius: 1,
    borderStyle: "dashed",
    borderWidth: 1,
    height: 1,
    marginVertical: 20,
    width: "100%",
    zIndex: 1,
  },
  dividerViewStyle: {
    backgroundColor: colors.white,
    bottom: 0,
    height: 1,
    left: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1,
  },
  dontClickText: { color: colors.darkerGrey, marginBottom: 10, textAlign: "center" },
  flex: { flex: 1 },
  headerLeftButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    left: 10,
    position: "absolute",
    top: 30,
    width: 40,
    zIndex: 99,
  },
  headerRightButton: {
    alignItems: "center",
    backgroundColor: colors.lightGrey,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    position: "absolute",
    right: 10,
    top: 10,
    width: 40,
    zIndex: 99,
  },
  image: { width: "100%" },
  modalContainer: {
    alignItems: "center",
    backgroundColor: colors.white,
    borderRadius: 20,
    padding: 20,
    maxWidth: 800,
    alignSelf: "center",
  },
  mt30: { marginTop: 30 },
  qrExpiredText: { marginTop: 10, textAlign: "center", width: "80%" },
  qrText: { textAlign: "center", width: "80%" },
  redeemLaterButton: {
    backgroundColor: colors.white,
    borderWidth: 1,
    flex: 1,
    marginRight: 20,
  },
  redeemModalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    width: "100%",
  },
  scrollContent: { paddingBottom: 100 },
  stickyBottomContainer: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    bottom: 0,
    elevation: 1,
    justifyContent: "center",
    paddingBottom: 20,
    padding: 10,
    position: "absolute",
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    width: "100%",
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 20,
    alignItems: "center",
    marginTop: 5,
  },
  usedExpiredText: { color: colors.lightGrey, padding: 10, textAlign: "center" },
  starbox: {
    minHeight: 150,
    width: "100%",
    backgroundColor: "white",
    // borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 3,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 3,
    borderColor: "black",
    position: "relative",
    borderStyle: "dotted",
    gap: 3,
  },
  cutoutLeft: {
    width: 20,
    height: 20,
    backgroundColor: "white",
    borderRadius: 20,
    borderColor: "black",
    borderWidth: 3,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    position: "absolute",
    left: -10,
  },
  cutoutRight: {
    width: 20,
    height: 20,
    backgroundColor: "white",
    borderRadius: 30,
    borderColor: "black",
    borderWidth: 3,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    position: "absolute",
    right: -10,
  },
  cutoutCenter: {
    width: "90%",
    height: 1,
    borderColor: "black",
    borderWidth: 2,
    position: "absolute",
    top: "50%",
    zIndex: -1, // Moves it to the back
  },

  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
})
